import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postItem } from '../Api'

export default generateApiAction({
  baseType: Types.ITEMS.POST,
  api: postItem,
  responseType: RESPONSETYPE.IDS
})



// WEBPACK FOOTER //
// ./src/actions/items/PostAction.js